module.exports = __webpack_public_path__ + "img/mx.82d0c2a8.svg";